import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const InstallPromptAndroid = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // Check if already in standalone mode
        if (window.matchMedia('(display-mode: standalone)').matches) {
            return;
        }

        const handler = (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            setDeferredPrompt(e);
            // Update UI notify the user they can install the PWA
            setIsVisible(true);
        };

        window.addEventListener('beforeinstallprompt', handler);

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        // Show the install prompt
        deferredPrompt.prompt();

        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);

        // We've used the prompt, and can't use it again, throw it away
        setDeferredPrompt(null);
        setIsVisible(false);
    };

    const handleDismiss = () => {
        setIsVisible(false);
    };

    // Logic to hide/show based on route
    if (!isVisible) return null;

    // Check if standalone (double check)
    if (window.matchMedia('(display-mode: standalone)').matches) return null;

    const isAuthRoute = ['/login', '/cadastro'].includes(location.pathname);
    const isPlatformRoute = location.pathname.startsWith('/plataforma');

    // Don't show on public home or other pages
    if (!isAuthRoute && !isPlatformRoute) return null;

    // Custom text for Platform
    const promptText = isPlatformRoute
        ? "Instale o App para acessar seus agendamentos mais rápido!"
        : "Deseja instalar o Sulash App?";

    // Optional: Different style for Platform (Top Bar) vs Auth (Bottom Banner)
    // For now, keeping the bottom banner but changing text as requested.
    // If user wanted Top Bar specifically for platform, we could adjust styles here.
    const bannerStyle = isPlatformRoute ? { ...styles.banner, bottom: 'auto', top: 0, borderTop: 'none', borderBottom: '1px solid #FF7EAF' } : styles.banner;

    return (
        <div style={bannerStyle}>
            <div style={styles.content}>
                <p style={styles.text}>{promptText}</p>
                <div style={styles.buttons}>
                    <button onClick={handleInstallClick} style={styles.primaryButton}>
                        Sim, instalar
                    </button>
                    <button onClick={handleDismiss} style={styles.secondaryButton}>
                        Agora não
                    </button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    banner: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: '#0c0c0c',
        borderTop: '1px solid #FF7EAF',
        padding: '1rem',
        zIndex: 9999,
        boxShadow: '0 -2px 10px rgba(0,0,0,0.5)',
        boxSizing: 'border-box',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
    },
    text: {
        color: '#fff',
        margin: 0,
        fontSize: '1rem',
        textAlign: 'center',
        fontFamily: '"Poppins", sans-serif',
    },
    buttons: {
        display: 'flex',
        gap: '1rem',
    },
    primaryButton: {
        backgroundColor: '#FF7EAF',
        color: '#fff',
        border: 'none',
        padding: '0.5rem 1rem',
        borderRadius: '5px',
        fontSize: '1rem',
        cursor: 'pointer',
        fontWeight: 'bold',
    },
    secondaryButton: {
        backgroundColor: 'transparent',
        color: '#ccc',
        border: '1px solid #ccc',
        padding: '0.5rem 1rem',
        borderRadius: '5px',
        fontSize: '1rem',
        cursor: 'pointer',
    },
};

export default InstallPromptAndroid;
